/**
 * StrategySettings - 전략/리스크 설정 페이지
 */
import React from 'react';
import './StrategySettings.css';
import { useStrategySettings } from '../hooks/useStrategySettings';
import StrategySettingsForm from '../components/settings/StrategySettingsForm';

const StrategySettings: React.FC = () => {
  const {
    settings,
    loading,
    saving,
    error,
    successMessage,
    loadSettings,
    saveSettings,
    setSettings,
  } = useStrategySettings();

  if (loading) {
    return (
      <div className="strategy-settings">
        <h2>전략/리스크 설정</h2>
        <div className="loading">
          <div className="spinner"></div>
          <p>로딩 중...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="strategy-settings">
      <h2>전략/리스크 설정</h2>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}

      <StrategySettingsForm
        settings={settings}
        onChange={setSettings}
        onSave={() => saveSettings(settings)}
        onCancel={loadSettings}
        saving={saving}
      />

      <div className="settings-info">
        <h3>현재 적용값</h3>
        <ul>
          <li>
            <strong>목표 수익률:</strong> {settings.targetProfitPercent}%
            {settings.enableTakeProfit ? ' (활성화)' : ' (비활성화)'}
          </li>
          <li>
            <strong>손절 비율:</strong> {settings.stopLossPercent}%
            {settings.enableStopLoss ? ' (활성화)' : ' (비활성화)'}
          </li>
          <li>
            <strong>매수 민감도:</strong> {settings.buyThreshold}
          </li>
          <li>
            <strong>매도 민감도:</strong> {settings.sellThreshold}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StrategySettings;
